import React, { useState } from "react";
import { Calendar, CheckCircle, Clock, AlertCircle, Camera, X } from "lucide-react";
import SkillDevelopmentDashboard from "./SkillDevelopmentDashboard";

interface Event {
  id: string;
  title: string;
  date: string;
  description: string;
  location: string;
  status: "upcoming" | "pending" | "achieved";
}

interface GalleryImage {
  id: string;
  src: string;
  alt: string;
  title: string;
  event: string;
  date: string;
}

const events: Event[] = [
  /* This section is update for Events display */
  {
    id: "1",
    title: "Vetri Vinayagar Temple Sponsorship – Community Development",
    date: "2025-06-10",
    description:
      "Successfully completed the sponsorship of domain registrations (www.vetrivinayagar.com & www.srivetrivinayagar.com), hosting, SSL certificate, and surveillance camera with internet access for Vetri Vinayagar Temple, Andakkapalayam, Coimbatore. Website development is in progress (content pending).",
    location: "Vetri Vinayagar Temple, Andakkapalayam, Coimbatore",
    status: "achieved"
  },{
    id: "2",
    title: "Mushroom Cultivation Training – Team Participation",
    date: "2025-07-11",
    description: "ADF-NGO-Event – Mushroom Cultivation Training successfully completed. Our team, consisting of Mr. Raffi A., Mr. Munver Sheriff A., Mr. Karthikeyan K, and Mr. Sasikumar M., participated in the training held at EDII, Periyakulam. The program focused on sustainable agriculture practices and entrepreneurship development. All members have successfully completed the training and received certificates.",
    location: "EDII, Periyakulam (from Coimbatore to Theni)",
    status: "achieved"
  },
  {
    id: "3",
    title: "3-Day Online Basic Class – Fruit Ice Cream, Falooda & Kulfi Making",
    date: "2025-07-24",
    description: "Our team will join the upcoming 3-day online class on Fruit Ice Cream, Falooda, and Kulfi making from July 24 to July 26, 2025. This training promotes home-based food entrepreneurship under our Skill Development Initiative.",
    location: "Online (Zoom)",
    status: "achieved"
  },
  {
    id: "4",
    title: "3-Day Online Training on Microgreens Production",
    date: "2025-07-29",
    description: "Our team will join the upcoming 3-day online training on Microgreens Production organized by EDII – Periyakulam Horti Business Incubation Forum and Samu Microgreens. The training covers indoor/outdoor techniques, seeds, investment, packaging, and more, conducted in Tamil via Zoom by Mrs. Samundeeswari.",
    location: "Online (Zoom)",
    status: "achieved"
  },    
  {
    id: "5",
    title: "Education Workshop",
    date: "2025-10-07",
    description:
      "Workshop on digital literacy and basic computer skills for underprivileged students.",
    location: "Coimbatore",
    status: "upcoming",
  },
  {
    id: "6",
    title: "Health Camp",
    date: "2025-10-21",
    description:
      "Free medical checkup and health awareness camp for rural communities.",
    location: "Vellanipatti",
    status: "upcoming",
  },
  {
    id: "7",
    title: "Environmental Drive",
    date: "2025-11-10",
    description: "Tree planting and environmental awareness campaign.",
    location: "Andakkapalayam",
    status: "upcoming",
  },
  {
    id: "8",
    title: "Skill Development Program",
    date: "2025-12-28",
    description: "Training program on web development and digital marketing.",
    location: "Coimbatore",
    status: "upcoming",
  },
];

const galleryImages: GalleryImage[] = [
  {
    id: "1",
    src: "https://marketstream.in/img/events/ADF-NGO-2-EVENT.png",
    alt: "Community volunteers working together",
    title: "Community Development Drive",
    event: "Vetri Vinayagar Temple",
    date: "2025-06-10"
  },
  {
    id: "2",
    src: "https://marketstream.in/img/events/ADF-NGO-EVENT-MushroomCultivationProgram.png",
    alt: "Mushroom Cultivation Training – Team Participation",
    title: "Mushroom Cultivation Workshop",
    event: "Education EDII Periyakulam (from Coimbatore to Theni)",
    date: "2025-07-11"
  },
  {
    id: "3",
    src: "https://marketstream.in/img/events/ADF-NGO-EVENT-MushroomCultivationProgram1.png",
    alt: "Mushroom Cultivation Training – Team Participation",
    title: "Mushroom Cultivation Workshop",
    event: "Education EDII Periyakulam (from Coimbatore to Theni)",
    date: "2025-07-11"
  },
  {
    id: "4",
    src: "https://marketstream.in/img/events/ADF-NGO-4-EVENT.png",
    alt: "Fruit Ice Cream Training – Team Participation",
    title: "Fruit Ice Cream, Falooda & Kulfi Making",
    event: "Entrepreneurship education development",
    date: "2025-07-24"
  },
  {
    id: "5",
    src: "https://marketstream.in/img/events/ADF-NGO-5-EVENT.png",
    alt: "Microgreens plantation activity Training – Team Participation",
    title: "Microgreens Production Training",
    event: "Entrepreneurship education development",
    date: "2025-07-29"
  },/*
  {
    id: "6",
    src: "https://images.pexels.com/photos/6646970/pexels-photo-6646970.jpeg",
    alt: "Tree plantation activity",
    title: "Environmental Conservation",
    event: "Tree Plantation",
    date: "2025-07-29"
  },
  {
    id: "5",
    src: "https://images.pexels.com/photos/6647000/pexels-photo-6647000.jpeg",
    alt: "Skill development training",
    title: "Technical Skills Training",
    event: "Skill Development",
    date: "2025-06-05"
  },
  {
    id: "6",
    src: "https://images.pexels.com/photos/6646919/pexels-photo-6646919.jpeg",
    alt: "Community meeting",
    title: "Community Outreach Program",
    event: "Social Welfare",
    date: "2025-06-07"
  },
  {
    id: "7",
    src: "https://images.pexels.com/photos/6647004/pexels-photo-6647004.jpeg",
    alt: "Youth engagement activity",
    title: "Youth Empowerment Session",
    event: "Youth Development",
    date: "2025-06-08"
  },
  {
    id: "8",
    src: "https://images.pexels.com/photos/6646971/pexels-photo-6646971.jpeg",
    alt: "Rural development project",
    title: "Rural Development Initiative",
    event: "Community Development",
    date: "2025-06-10"
  }*/
];

const Events: React.FC = () => {
  const [activeTab, setActiveTab] = useState<
    "upcoming" | "pending" | "achieved"
  >("upcoming");
  const [selectedImage, setSelectedImage] = useState<GalleryImage | null>(null);

  const filteredEvents = events.filter((event) => event.status === activeTab);

  const getStatusIcon = (status: string) => {
    switch (status) {
      case "upcoming":
        return <Clock className="w-6 h-6 text-primary" />;
      case "pending":
        return <AlertCircle className="w-6 h-6 text-warning" />;
      case "achieved":
        return (
          <div className="flex items-center justify-center w-10 h-10 bg-success/10 rounded-full">
            <CheckCircle className="w-7 h-7 text-success" />
          </div>
        );
      default:
        return null;
    }
  };

  const openImageModal = (image: GalleryImage) => {
    setSelectedImage(image);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center mb-8">
            <Calendar className="w-8 h-8 text-primary mr-3" />
            <h1 className="text-3xl md:text-4xl font-bold">Events</h1>
          </div>

          <div className="flex space-x-4 mb-8">
            <button
              onClick={() => setActiveTab("upcoming")}
              className={`px-4 py-2 rounded-md transition-colors ${
                activeTab === "upcoming"
                  ? "bg-primary text-primary-foreground"
                  : "bg-card hover:bg-primary/10"
              }`}
            >
              Upcoming
            </button>
            <button
              onClick={() => setActiveTab("pending")}
              className={`px-4 py-2 rounded-md transition-colors ${
                activeTab === "pending"
                  ? "bg-primary text-primary-foreground"
                  : "bg-card hover:bg-primary/10"
              }`}
            >
              Pending
            </button>
            <button
              onClick={() => setActiveTab("achieved")}
              className={`px-4 py-2 rounded-md transition-colors ${
                activeTab === "achieved"
                  ? "bg-primary text-primary-foreground"
                  : "bg-card hover:bg-primary/10"
              }`}
            >
              Achieved
            </button>
          </div>

          <div className="space-y-6 mb-16">
            {filteredEvents.map((event) => (
              <div
                key={event.id}
                className="bg-card rounded-lg p-6 shadow-subtle dark:shadow-subtle-dark border border-border hover:shadow-lg transition-shadow duration-300 animated-section"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1 pr-4">
                    <h3 className="text-xl font-semibold mb-2">
                      {event.title}
                    </h3>
                    <p className="text-muted-foreground">{event.description}</p>
                  </div>
                  <div className="flex-shrink-0">
                    {getStatusIcon(event.status)}
                  </div>
                </div>
                <div className="flex items-center justify-between text-sm text-muted-foreground">
                  <div className="flex items-center">
                    <Calendar className="w-4 h-4 mr-2" />
                    {new Date(event.date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </div>
                  <div>{event.location}</div>
                </div>
              </div>
            ))}

            {filteredEvents.length === 0 && (
              <div className="text-center py-8 text-muted-foreground">
                No {activeTab} events found.
              </div>
            )}
          </div>

          {/* Skill Development Dashboard */}
          <SkillDevelopmentDashboard />

          {/* Photo Gallery Section */}
          <div className="border-t border-border pt-16 mt-16">
            <div className="flex items-center mb-8">
              <Camera className="w-8 h-8 text-primary mr-3" />
              <h2 className="text-3xl md:text-4xl font-bold">Event Photo Gallery</h2>
            </div>
            
            <p className="text-lg text-muted-foreground mb-8 text-center">
              Capturing moments from our community initiatives and volunteer activities
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {galleryImages.map((image) => (
                <div
                  key={image.id}
                  className="group relative aspect-square overflow-hidden rounded-lg cursor-pointer animated-section"
                  onClick={() => openImageModal(image)}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-300 flex items-end">
                    <div className="p-4 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                      <h4 className="font-semibold text-sm mb-1">{image.title}</h4>
                      <p className="text-xs opacity-90">{image.event}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
          onClick={closeImageModal}
        >
          <div 
            className="relative max-w-4xl w-full max-h-[90vh] bg-card rounded-lg overflow-hidden animate-fade-in"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeImageModal}
              className="absolute top-4 right-4 z-10 p-2 bg-black/50 text-white rounded-full hover:bg-black/70 transition-colors"
              aria-label="Close image"
            >
              <X className="w-5 h-5" />
            </button>
            
            <div className="aspect-video relative">
              <img
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="w-full h-full object-cover"
              />
            </div>
            
            <div className="p-6">
              <h3 className="text-xl font-semibold mb-2">{selectedImage.title}</h3>
              <div className="flex items-center justify-between text-sm text-muted-foreground">
                <span>{selectedImage.event}</span>
                <span>{new Date(selectedImage.date).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Events;